export const getNights = (): string => {
  return document.querySelector<HTMLInputElement | HTMLSelectElement>('[name="night"]')?.value ?? ''
}

export const setNights = (value: string): void => {
  const nightEl = document.querySelector<HTMLInputElement | HTMLSelectElement>('[name="night"]')
  if (!nightEl) {
    return
  }
  nightEl.value = value
}
